import React from 'react'
import { BeatLoader } from 'react-spinners'

function Spinner({ size = 20, color = "#009EDF", margin = "0 auto", loading = true }) {
    return (
        <BeatLoader className='flex h-screen items-center justify-center mt-8' loading={loading} color={color} size={size} margin={margin} />
    )
}

export default Spinner